/** Decision layer (ADR-0059): decision nodes in the builder, decision lines in chat, answering. */
export default {
  en: {
    line: {
      decided: "Decided: {{value}} — {{pct}} sure",
      uncalibrated: "(not calibrated)",
      askedPerson: "Not sure ({{pct}}) — asked a person",
      careful: "Not sure ({{pct}}) — took the careful path",
      byPerson: "A person decided: {{value}}",
      unknownPct: "?",
      yes: "Yes",
      no: "No",
      aria: "Agent decision",
    },
    answer: {
      title: "The agent is not sure — please decide",
      question: "Question",
      suggested: "Suggested by the agent — {{pct}} sure",
      uncalibrated: "The agent's confidence is not calibrated yet.",
      pick: "Your answer",
      submit: "Send my answer",
      done: "Answer sent. The agent continues with your choice.",
      failed: "The answer could not be sent: {{message}}",
      notAllowed: "Waiting for someone in the {{queue}} queue to decide.",
    },
    editor: {
      section: "Decision",
      help: "Let the agent decide, and ask a person when it isn't sure.",
      question_ar: "Question (Arabic)",
      question_en: "Question (English)",
      kind: "Kind of answer",
      kinds: { choice: "Pick one option", boolean: "Yes or no", score: "Score on a scale" },
      options: "Options",
      optionValue: "Option {{n}} value",
      optionLabel_ar: "Option {{n}} label (Arabic)",
      optionLabel_en: "Option {{n}} label (English)",
      removeOption: "Remove option {{n}}",
      addOption: "Add option",
      rubricMin: "Lowest score",
      rubricMax: "Highest score",
      anchors: "Score points",
      anchorValue: "Point {{n}} value",
      anchorLabel_ar: "Point {{n}} meaning (Arabic)",
      anchorLabel_en: "Point {{n}} meaning (English)",
      removeAnchor: "Remove point {{n}}",
      addAnchor: "Add point",
      input: "What the agent reads",
      inputHelp: "Text that can include references such as {{example}} to the run's data.",
      threshold: "Confidence needed",
      thresholdHelp: "Below this, the low-confidence step applies.",
      lowConfidence: "When the agent is not sure",
      ask: "Ask a person",
      route: "Go to another step",
      roles: "Who can decide",
      routeTo: "Step to go to",
      outputKey: "Save the answer as",
      edgeOption: "This path is for",
      edgeOptionHelp: "Each path leaving a decision is taken when the agent (or a person) picks its option.",
      lowConfidenceEdge: "Not sure",
    },
  },
  ar: {
    line: {
      decided: "القرار: {{value}} — بثقة {{pct}}",
      uncalibrated: "(غير معايَر)",
      askedPerson: "غير متأكد ({{pct}}) — طُلب القرار من شخص",
      careful: "غير متأكد ({{pct}}) — سلك المسار الحذر",
      byPerson: "قرّر شخص: {{value}}",
      unknownPct: "؟",
      yes: "نعم",
      no: "لا",
      aria: "قرار الوكيل",
    },
    answer: {
      title: "الوكيل غير متأكد — يرجى اتخاذ القرار",
      question: "السؤال",
      suggested: "اقتراح الوكيل — بثقة {{pct}}",
      uncalibrated: "ثقة الوكيل غير معايَرة بعد.",
      pick: "إجابتك",
      submit: "إرسال إجابتي",
      done: "أُرسلت الإجابة. يتابع الوكيل باختيارك.",
      failed: "تعذّر إرسال الإجابة: {{message}}",
      notAllowed: "بانتظار قرار أحد أعضاء قائمة {{queue}}.",
    },
    editor: {
      section: "قرار",
      help: "دع الوكيل يقرر، واطلب من شخص عندما لا يكون متأكدًا.",
      question_ar: "السؤال (بالعربية)",
      question_en: "السؤال (بالإنجليزية)",
      kind: "نوع الإجابة",
      kinds: { choice: "اختيار خيار واحد", boolean: "نعم أو لا", score: "درجة على مقياس" },
      options: "الخيارات",
      optionValue: "قيمة الخيار {{n}}",
      optionLabel_ar: "تسمية الخيار {{n}} (بالعربية)",
      optionLabel_en: "تسمية الخيار {{n}} (بالإنجليزية)",
      removeOption: "إزالة الخيار {{n}}",
      addOption: "إضافة خيار",
      rubricMin: "أدنى درجة",
      rubricMax: "أعلى درجة",
      anchors: "نقاط المقياس",
      anchorValue: "قيمة النقطة {{n}}",
      anchorLabel_ar: "معنى النقطة {{n}} (بالعربية)",
      anchorLabel_en: "معنى النقطة {{n}} (بالإنجليزية)",
      removeAnchor: "إزالة النقطة {{n}}",
      addAnchor: "إضافة نقطة",
      input: "ما يقرؤه الوكيل",
      inputHelp: "نص يمكن أن يتضمن مراجع مثل {{example}} إلى بيانات التشغيل.",
      threshold: "الثقة المطلوبة",
      thresholdHelp: "إذا كانت الثقة أقل من ذلك تُطبَّق خطوة عدم التأكد.",
      lowConfidence: "عندما لا يكون الوكيل متأكدًا",
      ask: "اسأل شخصًا",
      route: "انتقل إلى خطوة أخرى",
      roles: "من يمكنه القرار",
      routeTo: "الخطوة التالية",
      outputKey: "احفظ الإجابة باسم",
      edgeOption: "هذا المسار لـ",
      edgeOptionHelp: "يُسلك كل مسار يخرج من القرار عندما يختار الوكيل (أو شخص) الخيار الخاص به.",
      lowConfidenceEdge: "غير متأكد",
    },
  },
};
